import React from 'react';

const ALetter = ({ stroke, ...props }) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.25 18.4059L7.5 5.65591L0.75 18.4059"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M19.5 18.6778C21.1569 18.6778 22.5 17.5026 22.5 16.0528C22.5 14.6031 21.1569 13.4278 19.5 13.4278C17.8431 13.4278 16.5 14.6031 16.5 16.0528C16.5 17.5026 17.8431 18.6778 19.5 18.6778Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M17.25 10.9435C17.8543 10.3632 18.6623 10.0434 19.5 10.0528C21.1594 10.0528 22.5 11.2247 22.5 12.6778V18.406"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12.2625 14.6559H2.73752"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export default ALetter;
